import React from "react";
import { styled } from "styled-components";
import EmptyCard from "../EmptyCard";
import Label from "../Text/Label";
import { TravelInformation } from "../TravelInformation";
import rem from "../../utils/rem";
const BookingCardContent = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${rem(20)};
`;
const BookingNumber = styled.div `
  font-size: ${rem(28)};
  line-height: ${rem(24)};
  margin: ${rem(10)} 0 0 0;
`;
const QrWrapper = styled.div `
  display: flex;
  justify-content: center;
  /* margin-bottom: ${rem(24)}; */
  > * {
    width: ${rem(71)};
    max-width: ${rem(71)};
  }
`;
const BookingInfo = styled.div `
  margin: 0 0 0 ${rem(16)};
  h5 {
    font-size: ${rem(14)};
  }
`;
const Actions = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: ${rem(16)};
  > button:not(:last-child) {
    margin-bottom: ${rem(8)};
  }
`;
export const BookingCard = ({ outbound, inbound, qrCode, bookingNumber, bookingNumberTitle = "Bookingnummer", header, children, banner, }) => (React.createElement(EmptyCard, { header: header },
    React.createElement(BookingCardContent, { style: {} },
        qrCode && React.createElement(QrWrapper, null, qrCode()),
        React.createElement(BookingInfo, null,
            React.createElement(Label, { as: "h5" }, bookingNumberTitle),
            React.createElement(BookingNumber, null, bookingNumber))),
    React.createElement(TravelInformation, { inbound: inbound, outbound: outbound }),
    banner && banner,
    React.createElement(Actions, null, children)));
export default BookingCard;
//# sourceMappingURL=BookingCard.js.map